import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import get from 'lodash.get';
// import { push } from 'react-router-redux';

import { fetchBranches } from 'modules/branches';

import Messages from 'components/Messages';
import LoadingOverlay from 'components/LoadingOverlay';
// import Pagination from 'components/Pagination';

import OutletItem from './item';

class BranchesPage extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isLoaded: PropTypes.bool.isRequired,
    error: PropTypes.bool.isRequired,
    errors: PropTypes.object.isRequired,
    branches: PropTypes.array.isRequired,
    totalPages: PropTypes.number.isRequired,
  };

  componentDidMount() {
    const { isLoading, dispatch } = this.props;

    // Do not fetch request if request already sent
    if (!isLoading) {
      dispatch(fetchBranches());
    }
  }

  /**
   * Page Changes
   */
  componentWillReceiveProps(nextProps) {
    // Check if page params is exists
    if (get(nextProps.match, 'params.page')) {
      const { isLoading, dispatch, match } = this.props;
      const page = nextProps.match.params.page;

      // Make sure page is different
      if (page !== match.params.page) {
        // Do not fetch request if request already sent
        if (!isLoading) {
          dispatch(fetchBranches({ page }));
        }
      }
    }
  }

  /**
   * Render product list
   */
  renderOutletList() {
    const { branches } = this.props;

    if (branches.length > 0) {
      return (
        <div className="products grid grid-uniform">
          {branches.map(data => <OutletItem key={data.id} data={data} />)}
        </div>
      );
    }

    return (
      <Messages>
Anda belum memiliki outlet yang terdaftar
      </Messages>
    );
  }

  render() {
    const { isLoading, isLoaded } = this.props;
    const showLoading = isLoading ? 'show' : '';

    return (
      <div className={`content-wrapper form-wrapper ${showLoading}`}>
        <div className="form-wrapper__inner">
          <div className="entry-header">
            <h2 className="block-title">Daftar Outlet</h2>
            <div className="text-medium text-color-gray-1 mb-30">
              Berikut adalah daftar outlet anda yang telah terdaftar di Dealpay.
            </div>
          </div>

          {isLoaded && this.renderOutletList()}
        </div>

        <LoadingOverlay />
      </div>
    );
  }
}

const mapStateToProps = ({ branches }) => ({
  ...branches,
});

export default withRouter(connect(mapStateToProps)(BranchesPage));



// WEBPACK FOOTER //
// ./src/pages/Branches/index.js